export default __webpack_public_path__ + "static/media/32.1b16714e.svg";